import React, { Component } from 'react';
import cx from 'classnames';
import {
  observeIntersection,
  unobserveIntersection,
} from '@ifit/mp-intersection-observer';
import { withTheme } from '@ifit/themes/withTheme';
import { CardSize, CardType, isSmallCard, isLargeCard, isSeries, isTrainer } from '@ifit/mp-card-utilities';
import './index.scss';

export interface ILazyLoadCardProps {
  children: React.ReactNode,
  cardSize?: CardSize,
  cardType?: CardType,
  isHorizontal?: boolean,
  themeClass?: string,
  isLoading?: boolean,
}

let disableLazyLoading = false;

export function skipLazyLoading() {
  disableLazyLoading = true;
}
export interface ILazyLoadState {
  inView: boolean
}
export class LazyLoad extends Component<ILazyLoadCardProps, ILazyLoadState> {
  state = {
    inView: disableLazyLoading,
  };

  ref = null;

  onRefSet = ref => {
    if (disableLazyLoading || this.ref === ref || this.state.inView) {
      return;
    }
    if (this.ref) {
      this.unobserve();
    }
    this.ref = ref;
    if (ref) {
      ref.addEventListener('changeInView', this.changeInView);
      observeIntersection(ref);
    }
  };

  changeInView = e => {
    this.setState({ inView: true });
    if (this.ref && e.detail.inView) {
      this.unobserve();
    }
  };

  unobserve = () => {
    /* @ts-ignore */
    this.ref.removeEventListener('changeInView', this.changeInView);
    unobserveIntersection(this.ref);
  };
  render() {
    const { cardSize, isHorizontal, cardType, children, isLoading = false, themeClass } = this.props;
    return (
      <div ref={this.onRefSet} className={`${themeClass}`}>
        {disableLazyLoading || (this.state.inView && !isLoading) ? (
          children
        ) : (
          <div
            className={cx('skeleton-placeholder', {
              large: isLargeCard(cardSize as CardSize),
              small: isSmallCard(cardSize as CardSize),
              horizontal: isHorizontal,
              series: isSeries(cardType as CardType),
              'trainer-card': isTrainer(cardType as CardType),
            })}
          />
        )}
      </div>
    );
  }
}

export default withTheme(LazyLoad);
